import { enUS } from 'date-fns/locale';

import { createBaseStringSet } from './createBaseStringSet';

const StringSetEn = createBaseStringSet({ dateLocale: enUS });

export default StringSetEn;
